import Vue from 'vue';
import FileSaver from 'file-saver';
import format from 'date-fns/format';

export const payrollOverviewsListingService = {
  async retrievePayrollOverviews(sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/payroll-overviews', {
        params: {
          ...sortOrder,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async retrieveFilteredRecordCount(searchParam) {
    return Vue.axios
      .get('/payroll-overviews/count-records', {
        params: {
          searchParam
        }
      })
      .then(response => response.data);
  },
  async downloadExcel(sortOrder, paginationParameters, searchParam) {
    const response = await Vue.axios({
      url: `/payroll-overviews/xlsx`,
      method: 'GET',
      params: {
        ...sortOrder,
        ...paginationParameters,
        searchParam
      },
      responseType: 'blob'
    });
    FileSaver.saveAs(
      response.data,
      `payroll-overviews-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`
    );
  },
  async downloadCSV(sortOrder, paginationParameters, searchParam) {
    const response = await Vue.axios({
      url: `/payroll-overviews/csv`,
      method: 'GET',
      params: {
        ...sortOrder,
        ...paginationParameters,
        searchParam
      },
      responseType: 'blob'
    });

    FileSaver.saveAs(
      response.data,
      `payroll-overviews-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.csv`
    );
  },

  async downloadPDF(sortOrder, paginationParameters, searchParam) {
    const response = await Vue.axios({
      url: `/payroll-overviews/pdf`,
      method: 'GET',
      params: {
        ...sortOrder,
        ...paginationParameters,
        searchParam
      },
      responseType: 'blob'
    });

    FileSaver.saveAs(
      response.data,
      `payroll-overviews-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.pdf`
    );
  },

  async printPDF(sortOrder, paginationParameters, searchParam) {
    const response = await Vue.axios({
      url: `/payroll-overviews/pdf`,
      method: 'GET',
      params: {
        ...sortOrder,
        ...paginationParameters,
        searchParam
      },
      responseType: 'blob'
    });

    const newBlob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.click();
  },

  async generatePayrollOverview(params) {
    return Vue.axios
      .post('/payroll-overviews/generate', { ...params })
      .then(response => response.data);
  }
};
